var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrongSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    fill: "none",
    viewBox: "0 0 19 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.654,
    cy: 9.988,
    r: 8.708,
    stroke: "#4B4B4B",
    strokeWidth: 1.084
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4B4B4B",
    strokeWidth: 2.167,
    d: "m5.229 6.055 8.7 8.7m.153-8.7-8.7 8.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongSign);
export default __webpack_public_path__ + "static/media/wrong-sign.4554c63c2e1b9289344f017358b58d2f.svg";
export { ForwardRef as ReactComponent };